import { notify } from "@/main";
import axios from 'axios';
import secureStorage from '@/utils/secureStorage';
import { API } from '@/config/api';

const state = {
    isLoggedIn: false,
    token: secureStorage.getItem('token') || null,
    user: secureStorage.getItem('user') || null,
};

const mutations = {
    login(state, { token, user }) {
        state.isLoggedIn = true;
        state.token = token;
        state.user = user;

        secureStorage.setItem('user', user);
    },
    logout(state) {
        state.isLoggedIn = false;
        state.token = null;
        state.user = null;

        secureStorage.removeItem('user');
    },
};

const actions = {
    async login({ commit }, { email, password }) {
        try {
            const response = await axios.post(
                API.LOGIN,
                {
                    email,
                    password,
                    token: "test",
                }
            );
            notify("Welcome!", "success");
            commit("login", { token: response.data.token, user: response.data.response.user });
            window.location.reload();
        } catch (error) {
            notify(
                "Login failed, please try again or contact support!",
                "error"
            );
            
        }
    },
    async logout({ commit }) {
        const userID = secureStorage.getItem("user").id;
        
        try {
            await axios.post(API.LOGOUT, {
                userId: userID,
                token: "test",
            });
            notify("Logout success", "success");
            commit("logout");
        } catch (error) {
            notify("Failed", "error");
            
        }
    },
};

const getters = {
    isLoggedIn: (state) => state.isLoggedIn,
    getToken: (state) => state.token,
    getUser: (state) => state.user,
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters,
};
